import styled from "styled-components";
import { size, palette } from "styled-theme";

const Wrapper = styled.div`
  .pdf-group {
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    height: 400px;
    max-height: 400px;
    overflow: auto;

    @media only screen and (min-width: ${size("M")}) {
      max-height: 800px;
      height: 800px;
    }
  }

  .esign-title {
    margin: 15px 0;
  }

  .react-pdf__Page {
    display: flex;
    flex-direction: column;
  }

  .react-pdf__Page__canvas {
    align-self: center;
  }

  .esign-download {
    text-align: left;
  }

  .download-container {
    padding: 10px 5px;
    background-color: ${palette("grayscale", 6)};

    button {
      background-color: ${palette("grayscale", 6)};
    }
  }

  .pdf-options {
    display: flex;
    justify-content: space-between;
    height: 90px;
    padding: 10px 0;
    box-shadow: 0 8px 6px -6px #C4C4C4;
    background-color: ${palette("grayscale", 6)};

    @media only screen and (min-width: ${size("M")}) {
      height: 35px;
    }

    @media only screen and (min-width: ${size("XS")}) {
      height: 70px;
    }

    @media only screen and (min-width: 320px) and (max-width: 378px) {
      height: 87px;
    }
  }

  .zoom-buttons {
    display: flex;
    align-items: flex-start;
    padding-top: 8px;
    justify-content: space-between;
    gap: 5px;
  }

  .zoom-in-button, .zoom-out-button {
    border: none;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    background-color: ${palette("grayscale", 6)};
  }

  .zoom-in-icon, .zoom-out-icon {
    color: ${palette("color", 26)};
  }

  .zoom-text {
    color: ${palette("color", 26)};
    font-weight: bold;
    padding-top: 5px;
  }
`;

export default Wrapper;
